import React from 'react'

const SupportEmail = () => {
    return <a href="mailto:gm_TDI_IIoT_Sensors@equinor.com">IIOT team</a>
}

export default SupportEmail
